if (!customElements.get('video-loader')) {
    customElements.define('video-loader', class videoLoader extends HTMLElement {

      constructor() {
        super();
        this.mql = window.matchMedia('(min-width: 990px)');
        this.mql.addEventListener("change", this.checkScreenChange.bind(this));
        this.checkScreenChange();
      }

      loadOnlyVisibleVideo(device) {
        var videos = document.querySelectorAll(`[data-${device}-video]`);
        videos.forEach((videoWrapper => {
            var video = videoWrapper.querySelector('video');
            if (video) {
            const visible = video.offsetWidth ||
                video.offsetHeight ||
                video.getClientRects().length;

            if (visible) {
                const children = video.getElementsByTagName("source");
                for (let i = 0; i < children.length; ++i) {
                  if (!children[i].src && children[i].dataset.src) {
                    children[i].src = children[i].dataset.src;
                  }
                }
                video.load();
                // Trigger play if autoplay attribute is set
                if (video.autoplay && video.muted) {
                  const playPromise = video.play();
                  if (playPromise !== undefined) {
                    playPromise.catch(error => {
                      console.log("Autoplay prevented:", error);
                    });
                  }
                }
            }
            }
        }));
      }

      checkScreenChange() {
        if (this.mql.matches){
          this.loadOnlyVisibleVideo('desktop')
        } else {
          this.loadOnlyVisibleVideo('mobile')
        }
      }
    })
  }